module.exports = __webpack_public_path__ + "img/axemaster_small.3f0ea7e3.png";